<template>
  <div id="map-dom">
    <!-- 级别显示组件 -->
    <BaseDrawshipcount
      v-if="data.showPlugin"
      :show-info="{
        textTitle: data.textTitle,
        text: data.text,
      }"
      :map="myMap"
    />
    <!-- 地图切换 -->
    <section
      v-if="data.showPlugin && !isMobile"
      absolute
      bottom-0
      right-0
      w="[20%]"
      z-999
    >
      <!--  @ts-ignore: TS2322 -->
      <BaseMapTitleLayer :map="myMap" />

      <!--
         <section style="position: absolute; z-index: 1000; left: 500px">
        <el-button @click="drawLine">绘制航线</el-button>
        <el-button @click="drawLineEdit">编辑航线</el-button>
        <el-button @click="cancleDrawLineEdit">取消编辑</el-button>
      </section>
      -->
    </section>
    <slot />
    <ul class="context-menu" :style="getRightMenuStyle">
      <slot name="rightMenu">
        <li style="color: #c0c4cc; cursor: not-allowed">
          {{ data.rightMenuShip?.name }}
        </li>
        <li
          v-for="(item, index) in getRightMenuList"
          :key="index"
          class="item"
          @click.stop="(e) => item.clickCallback?.(e, data.rightMenuShip)"
        >
          {{ item.label }}
        </li>
      </slot>
    </ul>
  </div>
</template>

<script setup lang="ts">
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  reactive,
  toRaw,
  unref,
} from 'vue'

import { merge } from 'lodash-unified'
import L from 'leaflet'
import { CommUtils, ShipxyAPI } from '@map-sdk/sdk'
import { useUtilsHooks } from '@map-sdk/hooks'

import {
  BaseMapTitleLayer,
  baseMapTitleLayerConfig,
} from '@map-sdk/components/mapTitleLayer'
import { BaseDrawshipcount } from '@map-sdk/components/drawshipcount'
import {
  UserAreas,
  UserLines,
  UserMarkers,
  portList,
  weatherList,
} from './instance'
import type { MyMap } from '@map-sdk/sdk'
import type { LatLng } from 'leaflet'
import type { ShowLayerType } from './instance'

defineOptions({
  name: 'BaseMapComponent',
})

const { isMobile, getMapTitleLayer, switchBaseMap } = useUtilsHooks()

export interface LeafletDom {
  // 任意属性
  [propName: string]: any
}
const getRightMenuList = computed(() => props.rightMenu) as any

let myMap: MyMap = null as any
const data: LeafletDom = reactive({
  // map对象
  mapDom: null,
  text: 0,
  textTitle: '当前绘制船舶数量：',
  drawer: false,
  selectShip: {},
  cbStyle: {},
  rightMenuShip: {},
  shipService: null,
  _drawInstance: null,
  defaultTestShip: [
    {
      name: '测试船舶定位船舶',
      source: 0,
      mmsi: 412321605,
      shipid: 'BF29CDE29F45D02E',
      lng: 121.121472,
      lat: 38.722985,
      cog: 163.1,
      sog: 6.2,
      rot: 327.67,
      is_radar: false,
      navistatus: 255,
      lastdyn: 1711503635,
      type: 30,
      length: 26,
      tracks: [],
      istop: false,
      state: 0,
      lineWidth: 1,
      rotate: 0,
      shiptype: 1,
    },
    {
      name: '测试预测轨迹船舶', // WAN RONG HAI
      source: 0,
      mmsi: '4131101',
      shipid: '6138CF3E5B032BD2',
      lng: 121.13555,
      lat: 38.727367,
      sog: 65.535,
      cog: 65.535,
      hdg: 65.535,
      rot: 32.767,
      tradetype: 99,
      type: 60,
      imo: '524288000',
      matchtype: 0,
      cnname: '',
      callsign: 'BAPO',
      length: 1300,
      width: 200,
      left: 150,
      trail: 1130,
      draught: 5000,
      dest: 'LANSHAN,CN',
      eta: '08-01 04:10',
      laststa: 1439241968,
      navistatus: 255,
      lastdyn: 1718602690,
      satelliteutc: 0,
    },
  ],
  sjShipTitleLayer: null,
})
// 创建 Worker 实例

const props = defineProps({
  rightMenu: {
    type: Array,
    default: () => [
      {
        label: '菜单1',
        clickCallback: (e: any, data: any) => {
          console.log('点击了click', e, data)
        },
      },
      {
        label: '菜单2',
      },
      {
        label: '菜单3',
      },
      {
        label: '菜单4',
      },
    ],
  },
})

onMounted(() => {
  ShipxyAPI.addDefaultHooks()
  initMap()
  // 在Vue组件内注册worker
  // new Worker(new URL('./worker.ts', import.meta.url), { type: 'module' })
})

/**
 * 关闭右键菜单
 */
const closeRightMenu = () => {
  data.shipService.closeRightMenu()
}

/**
 * 计算右键菜单所需要的样式
 */
const getRightMenuStyle = computed(() => data.cbStyle)

// 初始化地图
declare global {
  interface Window {
    myMap: MyMap
  }
}

const initMap = (): void => {
  //options
  const options = {
    //defaultMapType: "MT_GOOGLE",// 默认显示图源
    //公司信息®
    attribution: {
      isShow: !isMobile.value,
      emptyString: '',
    },
    scaleCtrl: {
      isShow: true,
      position: 'bottomleft',
    },
    //中心点
    centerPoint: [32.22, 105.22],
    mapTypes: ['MT_SEA', 'MT_GOOGLE', 'MT_SATELLITE'],
    //初始缩放等级
    zoom: 4,
    //尺子 测距
    measureCtrl: {
      isShow: false,
      position: 'bottomright',
      showMeasurementsMeasureControl: false,
      showMeasurementsClearControl: false,
      showUnitControl: true,
      oneCloseCallBack(count: any) {
        console.log('关闭事件', count)
      },
      finalizeCallBack() {
        console.log('完成事件')
      },
    },
    //鼠标移动悬浮经纬度控件
    mousePostionCtrl: { isShow: !isMobile.value, position: 'bottomleft' },
    //缩放控件的显示隐藏
    zoomControlElane: { isShow: !isMobile.value, position: 'topleft' },
    //1-12 级别展示
    zoomviewControl: { isShow: false },
    //过度动画
    //zoomAnimation: true,
    //回调
    mapReadyCallBack(map: MyMap) {
      console.log('地图准备完成，进行初始化', map)
      data.showPlugin = true
    },
    addTileLayer: [],
  }
  myMap = new ShipxyAPI.Map('map-dom', options as any)
  window.myMap = myMap
  // 获取map对象 参数：地理中心和缩放
  myMap.setView([30.508383, 114.393644])
  emit('initMap', myMap)
  switchBaseMap(myMap, getMapTitleLayer(myMap, baseMapTitleLayerConfig)[0])

  const res = ShipxyAPI.ShipService(myMap as any, {
    enableAreaShip: true,
    delayTime: 5000,
    generalLabelZoom: 3,
    zoomLevel_base: 3,
    dShipColor: '#ff6600',
    lableFont: ['500 12px Arial', '500 12px 微软雅黑'], // 船舶名称，文字字体，默认值：["600 12px Arial", "500 12px Arial"]
    lableTxtColor: ['#1d374c', '#1d374c'], // 船舶名称，文字颜色，默认值：["#000","#fff"]
    lableLineColor: ['rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 1)'], //  边框颜色，默认值：["#000","#000"]
    drawBaseShipsGridZoom: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], // 级别，0.05°网格显示船舶数量限制级别，默认：[]
    drawBaseShipsGridMax: [1, 2, 3, 5, 6, 7, 9, 10, 30, 0], // 数量，0.05°网格显示船舶数量限制数量，默认：[]，大于0生效
    drawBaseShipsGridMaxCount: 100, // 绘制船大于该数量，开启网格抽稀绘制，默认：0，大于0生效
    monitorShips: [], //安装了监控船,
    drawShipsEndCallBack: ({ count, zoom }) => {
      data.text = `${zoom}级 - ${count}艘`
      data.textTitle = `地图缩放级别为${zoom}级；屏幕内显示船舶数量为:${count}艘`
    },
  })

  // 注册船舶选中事件
  res.addSelectedListener((shipObj: any) => {
    data.drawer = true
    data.selectShip = shipObj
    emit('selectShipItem', shipObj)
  })
  res.addSelectedShipUpdateListener((obj: any) => {
    emit('selectedShipUpdate', obj)
  })

  res.addRightContextmenuListener((ship, style) => {
    data.cbStyle = style
    data.rightMenuShip = ship
    emit('rightMenuShip', { ship, style })
  })
  data.shipService = res

  // 船舶定位
  // shipShow()
  // 轨迹展示 / 回放
  // 航线预测集合气象

  // 轨迹点
  // showTrack()
  // 气象预测轨迹
  // showTrackForecast()

  // 航行警告
  // showNavigationalWarning()
}

/**
 * 显示船舶
 */
const shipShow = (shipList = [], orgId?: string) => {
  data.shipService.addShips(shipList.length ? shipList : data.defaultTestShip)
}
const showShipSj = (url: any, options: any) => {
  data.sjShipTitleLayer = ShipxyAPI.ShipSjService(url, options)

  // sj.createTile = function (coords: {
  //   scaleBy: (arg0: any) => any
  //   z: number | undefined
  //   x: any
  //   y: any
  // }) {
  //   const tile = L.DomUtil.create('canvas', 'leaflet-tile')
  //   const ctx = tile.getContext('2d')
  //   if (!ctx) {
  //     console.error('Failed to get 2D context for tile canvas.')
  //     return tile
  //   }
  //   const size = this.getTileSize()
  //   tile.width = size.x
  //   tile.height = size.y

  //   // 将切片号乘以切片分辨率，默认为256pixel,得到切片左上角的绝对像素坐标
  //   const nwPoint = coords.scaleBy(size)

  //   // 根据绝对像素坐标，以及缩放层级，反投影得到其经纬度
  //   const nw = myMap.unproject(nwPoint, coords.z)

  //   ctx.fillStyle = 'white'
  //   ctx.fillRect(0, 0, size.x, 50)
  //   ctx.fillStyle = 'black'
  //   ctx.fillText(`x: ${coords.x}, y: ${coords.y}, zoom: ${coords.z}`, 20, 20)
  //   ctx.fillText(`lat: ${nw.lat}, lon: ${nw.lng}`, 20, 40)
  //   ctx.strokeStyle = 'red'
  //   ctx.beginPath()
  //   ctx.moveTo(0, 0)
  //   ctx.lineTo(size.x - 1, 0)
  //   ctx.lineTo(size.x - 1, size.y - 1)
  //   ctx.lineTo(0, size.y - 1)
  //   ctx.closePath()
  //   ctx.stroke()
  //   return tile
  // }

  data.sjShipTitleLayer.addTo(myMap)
  data.sjShipTitleLayer.setZIndex(30)
}

const hideShipSj = () => {
  data.sjShipTitleLayer &&
    data.sjShipTitleLayer.remove() &&
    (data.sjShipTitleLayer = null)
}
/**
 * 显示轨迹点
 * @param trackList 轨迹集合可不传
 * @return trackId  轨迹点id
 */
const showTrack = (
  trackId: string,
  shipInfo = { name: '测试船舶', mmsi: '0000000' },
  trackList = [],
  options = {
    // lineColor:'' 线条颜色
    // aiDetection:{
    //   show: true, data: [{
    //   startTime: 1717449567,
    //   endTime: 1717451243,
    //   color: '#de6763',
    //   navInfo: {
    //     ATD: 1717449567,
    //     ETA: 1717451243,
    //     airPressure: '12',
    //     airTemp: '11',
    //     beaufortScale: '3',
    //     departure: '',
    //     destination: '描述信息',
    //     position: [],
    //     speedCourse: '5',
    //     status: '正常',
    //     visibility: '2',
    //     windSpeed: '1',
    //   },
    // }]
    // }
  }
) => {
  if (!myMap) return
  trackId = trackId || CommUtils.getUuid(12)
  // 轨迹点
  const trackService = ShipxyAPI.TrackService(toRaw(myMap), {
    maxStopSpeed: 2, //最大停留速度
  })
  const lineColor = [
    '#9C27B0',
    '#0d61be',
    '#008a3e',
    '#b71b61',
    '#c5912e',
    '#69f',
    '#f00',
    '#2770d4',
    '#E91E63',
    '#00BCD4',
  ]
  trackService.addAndShow(
    trackId,
    trackList || [],
    merge(
      {
        maxStopSpeed: 2,
        lableMap: {},
        isShowLable: true, //是否显示lable，默认值：true
        lineColor: lineColor[Math.floor(Math.random() * lineColor.length)], // 轨迹线颜色
        circleOverColor: 'yellow', // 拐点，鼠标滑过时的颜色
        dash: false, // 是否为虚线，true：虚线，false：实线，默认：false
        dashArray: [5, 5], // 虚线参数，默认：[5,5]
        directionShow: true, // 轨迹方向三角是否展示，默认值：false
        isEnablePlayer: false, //是否需要播放轨迹，默认值：false
        showTimeType: ['stop'],
        startShow: false, // 是否显示“起点”图标，默认值：true
        endShow: false, // 是否显示“终点”图标，默认值：true
        tipHideTimeOut: 30000,
        lableFields: ['name', 'mmsi', 'utc', 'kn', 'md', 'lat', 'lng'], // 轨迹点信息显示 'sog', 'cog',
        notDiluteZoom: [15, 16, 17, 18],
        startCircleType: 2, // 起始圆圈样式类型，0：不显示，1:同心圆，2：普通圆圈，与拐点相同， 默认：1
        endCircleType: 2, // 结束圆圈样式类型，0：不显示，1:同心圆，2：普通圆圈，与拐点相同， 默认：1
        startCircleColor: '#fff', // 起始圆圈填充色， 默认：'#06c84a'
        endCircleColor: '#fff', // 结束圆圈填充色， 默认：'#f70006'
        // ai 检测
        aiDetection: {
          show: false,
          activityColor: '#06c84a',
          datas: [
            // {
            //   startTime: 1717449567,
            //   endTime: 1717451243,
            //   color: '#de6763',
            //   navInfo: {
            //     ATD: 1717449567,
            //     ETA: 1717451243,
            //     airPressure: '12',
            //     airTemp: '11',
            //     beaufortScale: '3',
            //     departure: '',
            //     destination: '描述信息',
            //     position: [],
            //     speedCourse: '5',
            //     status: '正常',
            //     visibility: '2',
            //     windSpeed: '1',
            //   },
            // },
            // {
            //   startTime: 1717450177,
            //   endTime: 1717451580,
            //   color: '#f4be70',
            // },
          ],
          event: {
            clickCallback: (item: any) => {
              console.log('点击回调函数', item)
              emit('aiDetectionClick', item)
            },
          },
        },
        emission: {
          show: false,
          arrawShow: false,
          arrawColor: '#f70006',
          //叠加污染值最小停留时间 单位：小时
          overlayMinStopTime: 1,
          //污染数据展示范围（线宽）
          weight: 20,
          // scalesMap: {
          //   co2: 1000 * 3.67
          // },
          //配色
          colorsMap: {
            default: 'rgba(0,0,0,0)',
            co2: [
              { value: 5, color: 'rgba(217,245,214,1)' },
              { value: 10, color: 'rgba(98,210,86,1)' },
              { value: 20, color: 'rgba(255,246,122,1)' },
              { value: 30, color: 'rgba(255,233,40,1)' },
              { value: 50, color: 'rgba(251,191,188,1)' },
              { value: 9999, color: 'rgba(247,105,100,1)' },
            ],
          },
          //数据
          datas: [
            {
              vessel_co2_day_atom_v2: 5 * 1000 * 24,
              datekey_rt: '2024-06-03',
            },
            {
              vessel_co2_day_atom_v2: 10 * 1000 * 24,
              datekey_rt: '2024-06-04',
            },
          ],
        },
      },
      options
    ) as any,
    shipInfo
  )
  return trackId
}

/**
 * 追加轨迹点 必须先调用显示轨迹才能追加
 * @param trackId 轨迹id
 * @param trackList 轨迹集合
 * @param aiDetectionList ai侦测集合
 */
const appendTrack = (trackId: string, trackList = [], aiDetectionList = []) => {
  myMap?.trackService.appendTracks(trackId, trackList, aiDetectionList)
}

/**
 * 追加轨迹点结束
 * @param trackId 轨迹id
 * @param trackList 轨迹集合
 * @param aiDetectionList ai侦测集合
 */
const appendFinish = (
  trackId: string,
  trackList = [],
  aiDetectionList = []
) => {
  myMap?.trackService.appendFinish(trackId)
}

/**
 * 隐藏轨迹点
 * @param trackId 轨迹id 在显示的时候已经回传
 * @param isHide 是否隐藏 true 隐藏 false 显示
 */
const hideOrShowTrack = (trackId: string, isHide = true) => {
  if (myMap && myMap.trackService) {
    if (isHide) {
      myMap.trackService.hide(trackId)
      return
    }
    myMap.trackService.hide(trackId)
  }
}

/**
 * 气象预测轨迹
 */
const showTrackForecast = () => {
  if (!myMap) return
  ShipxyAPI.TrackService(myMap, {
    maxStopSpeed: 2, //最大停留速度
  })
  const trackForecast = ShipxyAPI.TrackForecast(myMap)
  trackForecast.begin()
}
/**
 * 隐藏气象预测轨迹
 */
const hideTrackForeacast = () => {
  if (myMap && myMap.trackForecast) {
    myMap.trackForecast.closeWin()
  }
}

/**
 * 航行警告
 */
const showNavigationalWarning = () => {
  if (!myMap) return
  const navigationalWarning = ShipxyAPI.NavigationalWarning(myMap)
  navigationalWarning.show()
}

const hideNavigationalWarning = (warningId?: string) => {
  if (myMap && myMap.navigationalWarning) {
    myMap.navigationalWarning.hide(warningId)
  }
}

// 船舶定位
const removeSelectShip = () => {
  data.shipService.cancelSelectedShip()
  data.shipService._drawShips()
}

/**
 * 开启绘制航线
 */
const drawLine = () => {
  //每次弹框产生唯一iD
  data.mathuuID = Math.random()
  //开启地图绘制
  //移除
  if (data._drawInstance) {
    data._drawInstance.removeTrack()
  }
  // 创建航线绘制对象
  data._drawInstance = ShipxyAPI.trackDrawSymbol(toRaw(unref(myMap)), {
    callBack: (item: any) => {
      console.log(item, 'item 绘制回调')
      emit('drawCallBack', item)
    },
    unit: 'nm',
    //显示标注
    showMarkerText: true,
    //显示文字
    showLineText: true,
    dash: true,
    dashArray: [5, 5],
    lineid: data.mathuuID,
    drawEndCallBack: (item: any) => {
      console.log('结束绘制：', item)
      if (!item.length) {
        // $('#drawhx').text('重新绘制')
        emit('drawEndCallBack', item)
      }
    },
  })
  //开启绘制
  data._drawInstance && data._drawInstance.drawTrack()

  //标记操作
  data._drawInstance && (data._drawInstance._op = 'draw')
}

/**
 * 取消编辑绘制航线
 */
const cancleDrawLineEdit = () => {
  data._drawInstance.cancelLine()
}
/**
 * 编辑绘制航线
 */
const drawLineEdit = () => {
  data._drawInstance.editLine()
}

// 定位船舶信息
const locate = (shipId: string) => {
  try {
    const ship = data.shipService.getShipByShipid(shipId)
    if (!ship) {
      return
    }
    removeSelectShip()
    data.shipService.locationShip(ship.mmsi, false, ship)
  } catch (e) {
    console.log(e)
  }
}

// 取消定位船舶
const cancelLocate = () => {
  if (data.shipService) data.shipService.cancelSelectedShip()
}

/**
 * 图层显示
 * @param value
 * @param typeName
 */
const showLayer = (
  typeName: ShowLayerType,
  value: boolean,
  layerTypeCode?: any,
  data?: any
) => {
  if (!myMap) return
  const map = toRaw(myMap)
  const areaView = ShipxyAPI.AreaViewSymbol(map)
  switch (typeName) {
    case 'showGlobalEEZArea':
      value ? areaView.showArea('EEZ', data) : areaView.hideArea('EEZ')
      break
    case 'showGlobalEmissionControlArea':
      value ? areaView.showArea('TYP') : areaView.hideArea('TYP')
      break
    case 'showBaselineOfChinaTerritorialSea':
      value ? areaView.showArea('BLINE') : areaView.hideArea('BLINE')
      break
    case 'showStraitsOfGlobalImportance':
      value ? areaView.showArea('QQHX') : areaView.hideArea('QQHX')
      break
    case 'showGlobalMarineArea':
      value ? areaView.showArea('GSEA') : areaView.hideArea('GSEA')
      break
    case 'showGlobalTimeZone':
      value ? areaView.showArea('TIME') : areaView.hideArea('TIME')
      break
    case 'showWarpAndLatitudeGrid':
      value
        ? ShipxyAPI.LatlngGraticuleServer(map).show()
        : ShipxyAPI.LatlngGraticuleServer(map).hide()
      break
    case 'showSeaAreaForecast':
      nextTick(() => {
        if (!map) return
        value
          ? ShipxyAPI.WeatherService(map).showSeaAreaForecasts(
              (done) => {
                done(weatherList as any)
                // lastValueFrom<SeaForecastInterFaca[]>(getWeatherSeaArea()).then((res) => {
                //   done(res)
                // })
              },
              (params) => {
                // console.log(params)
                // status.weatherDetail = params
                // status.isOpenWeatherDetail = true
              }
            )
          : ShipxyAPI.WeatherService(map).hideSeaAreaForecasts()
      })
      break
    case 'showTyphoon':
      if (value) {
        // 显示台风列表
        ShipxyAPI.WeatherService(map).showTyphoonInfoList(
          (e: any) => {
            console.log('回调', e)
          },
          true,
          null,
          (tfinfo: any, done: any) => {
            // lastValueFrom(getWeatherTyphoonDetail({ tfbh: tfinfo.id })).then((res: any) => {
            //   done(res.realpoints)
            // })
          },
          { showWarningLine: true, autoLocation: true, showTimeTipMinZoom: 6 }
        )
      } else {
        ShipxyAPI.WeatherService(map).hideTyphoonInfoList()
      }
      break
    case 'showSeaBreeze':
      value
        ? ShipxyAPI.WeatherService(map).showWindFiel(
            Date.now().toString(),
            data
          )
        : ShipxyAPI.WeatherService(map).hideWindFiel()
      break
    case 'showTide':
      value
        ? ShipxyAPI.WeatherService(map).showTides()
        : ShipxyAPI.WeatherService(map).hideTides()
      break
    case 'showSeaRoute':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('SEA_ROUTE')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('SEA_ROUTE')
      break
    case 'showFisheryManager':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('FISHERY_MANAGER')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('FISHERY_MANAGER')
      break
    case 'showEarthQuakeAreaSymbol':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('EARTH_QUAKE')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('EARTH_QUAKE')
      break
    case 'showPiratesSymbol':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('PIRATE')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('PIRATE')
      break
    case 'showCollisionRiskSymbol':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('COLLISION_RISK')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('COLLISION_RISK')
      break
    case 'showObstacleareaSymbol':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('OBSTACLEAREA')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('OBSTACLEAREA')
      break
    case 'showFinshAreaSymbol':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('FISHAREA')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('FISHAREA')
      break
    case 'showTerminatorSymbol': {
      ShipxyAPI.TerminatorSymbolServer(map).toggleVisibility(value)

      break
    }
    case 'showShipAccidentSymbol':
      value
        ? ShipxyAPI.AreaViewSymbol(map).showArea('SHIPACCIDENT')
        : ShipxyAPI.AreaViewSymbol(map).hideArea('SHIPACCIDENT')
      break
    case 'showAisManager':
      value
        ? ShipxyAPI.aisManagerService(map, {
            loadAisShip: (
              params: L.LatLngBounds,
              done: (shipList: any) => void
            ) => {
              console.log(params, done)
            },
          }).show()
        : ShipxyAPI.aisManagerService(map, {}).hide()
      break
    case 'showPort':
      value
        ? ShipxyAPI.PortService(map).show((done) => {
            // lastValueFrom<any>(getPortList()).then(({ result }) => {
            //   done(result)
            // })
            done(portList as any)
          })
        : ShipxyAPI.PortService(map).hiden()
      break
    case 'showWind':
      value
        ? ShipxyAPI.WeatherService(map).showSeaBreezes(
            Date.now().toString(),
            data
          )
        : ShipxyAPI.WeatherService(map).hideSeaBreezes()
      break
    case 'showHL':
      value
        ? ShipxyAPI.WeatherService(map).showSeaWater(
            Date.now().toString(),
            data
          )
        : ShipxyAPI.WeatherService(map).hideSeaWater()
      break
    case 'showHaiLang':
    case 'showWaterTemperature':
    case 'showIceCondition':
    case 'showSeaIce':
    case 'showSeaBreezeLayer':
    case 'showSeaBreezeArrow':
    case 'showRainfall':
    case 'showAtmosphericPressure':
    case 'showVisibility':
    case 'showAirTemperature':
    case 'showSeaWave':
    case 'showWaveArrow':
      if (!layerTypeCode) return
      value
        ? ShipxyAPI.WeatherService(map).showWeatherLayerTile(
            layerTypeCode,
            Date.now().toString()
          )
        : ShipxyAPI.WeatherService(map).hideWeatherLayerTile(layerTypeCode)
      break
    case 'showYangliu':
      value
        ? ShipxyAPI.WeatherService(map).showOceanCurrentFiel(
            Date.now().toString(),
            data
          )
        : ShipxyAPI.WeatherService(map).hideOceanCurrentFiel()
      break
    default:
      break
  }
}

/**
 * 绘制图形
 * @param type  Rectange： 长方形/ 正方形 Polygon ：多边形  Circle ：圆形 Sector：扇形 Ellipse：椭圆
 */
const drawPoline = (
  type:
    | 'clear'
    | 'Rectange'
    | 'Polygon'
    | 'Circle'
    | 'Sector'
    | 'FreeDraw'
    | 'Ellipse'
) => {
  if (!myMap) return
  const overLayers = ShipxyAPI.overLayers(toRaw(myMap))
  if ('Sector' === type) {
    const centerLatLng = myMap.getCenter()
    // 扇形
    const semicircle = myMap.Draw.show([centerLatLng], {
      shape: 'Sector',
      pathOptions: {
        radiusY: 300,
        endAngle: 90,
        color: '#ff7800',
        fillColor: '#ff7800',
        radius: 60, // 半径，单位米
        startAngle: -45, // 起始角度，以度为单位，从北方开始逆时针计算
        stopAngle: 45, // 结束角度
        fillOpacity: 0.5, // 填充透明度
        stroke: true,
        dashArray: [],
        weight: 3,
        opacity: 1,
        clickable: true,
        draggable: false, // 是否可拖动，默认为false
        keyboard: true,
        zIndexOffset: 1000,
      },
      locate: true,
    })
    myMap.Draw.edit(semicircle)
    return
  }
  if ('Ellipse' === type) {
    const centerLatLng = myMap.getCenter()
    // 椭圆的参数
    const majorRadius = 200 // 横轴半径，单位为米
    const minorRadius = 100 // 纵轴半径，单位为米
    const axis = 'north' // 椭圆的轴方向，可以是'center', 'west', 'east', 'north' 或 'south'
    const rotation = 40 // 椭圆的角度，单位为度
    // 绘制椭圆
    const ellipse = myMap.Draw.show([centerLatLng], {
      shape: 'Ellipse',
      pathOptions: {
        axis,
        angle: 0,
        color: 'red',
        weight: 1,
        fillOpacity: 0.2,
        fillColor: '#f03',
        radius: [majorRadius, minorRadius, rotation],
      },
      locate: true,
    })
    myMap.Draw.edit(ellipse)
    return
  }
  if ('clear' === type) {
    overLayers.removeInstanceLayer()
    return
  }
  overLayers.initDraw(type)
}

/**
 * 显示图层
 */
const showArea = (type: string, dataList?: any[]): void => {
  const overLayers = ShipxyAPI.overLayers(toRaw(myMap) as any)
  switch (type) {
    case 'areas':
      ;(dataList?.length ? dataList : UserAreas).forEach((item: any) =>
        overLayers.showArea(item, true)
      )
      break
    case 'lines':
      ;(dataList?.length ? dataList : UserLines).forEach((item: any) =>
        showLine(item)
      )
      break
    case 'markers':
      overLayers.drawMarkClear()
      ;(dataList?.length ? dataList : UserMarkers).forEach((item: any) =>
        overLayers.showMarker(item)
      )
      break
  }
}

// 回显航线
const showLine = (line: any, loc = true) => {
  const latLng: any[] = []
  if (loc) {
    //构造数据结构
    line &&
      line.Points &&
      line.Points.split(',').forEach((item: any, i: number) => {
        if (i % 2) {
          latLng[Math.floor(i / 2)]['lat'] = item
        } else {
          latLng.push({ lng: item })
        }
      })

    //显示当前航线
    const options = {
      callBack: (item: any) => {
        console.log(item)
        //e.data = item || [];
        // this._curLineID == this.lineid && this.lineDetail(item || [])
      },
      unit: 'nm',
      //显示标注
      showMarkerText: !!1,
      //显示文字
      showLineText: !!1,
      dash: !!1,
      dashArray: [5, 5],
      //标记当前 航线
      lineid: line.LineID,
      lineColor: line.Style ? JSON.parse(line.Style).color : '#f00',
      lineTextColor: line.Style ? JSON.parse(line.Style).color : '#f00',
    }
    const _tempLatLngs: LatLng[] = []
    latLng.forEach((item) => {
      // 转化成当前地图坐标
      _tempLatLngs.push(L.latLng(item.lat, item.lng))
    })

    //TODO: 先移除
    // this.hashInstance[lineid] && this.hashInstance[lineid].removeTrack()
    //添加实例
    // this.hashInstance[lineid] =
    ShipxyAPI.trackDrawSymbol(myMap, options, _tempLatLngs)

    //显示
    // latLng.length > 1 && linetrack.showTrack(_tempLatLngs, loc, null)
    //标识变量调整
    line._isshow = false
  }
}

/**
 * 定位海盗
 */
const localPirate = (id = '2467') => {
  if (myMap) {
    myMap.pirateService.openMarkPophtmlByMarkID(id)
  }
}
/**
 * 取消定位海盗
 */
const cancelLocalPirate = () => {
  myMap && myMap.pirateService.locationClose()
}

/**
 * 初始化ais航标
 */
const initNavigation = () => {
  if (!myMap) return
  const { lat, lng } = myMap.getCenter()
  myMap.setView([lat, lng], 5)
  ShipxyAPI.NavigationService(toRaw(myMap), {
    isShow: true,
    iconScale: 0.7,
    smallIconScale: 0.9,
    isSelectedShowReal: false,
    onClick: (arrNav: any) => {
      if (arrNav) {
        const _nav = arrNav[0]
        console.log(_nav.data.options)
        // showNavBox(_nav.data.options)
        myMap &&
          myMap.navigationService.setSelectedNavigation(
            _nav.data.options.data.mmsi
          ) //选中
      }
    },
  })
}

/**
 * 显示ais航标
 */
const showNavigation = () => {
  if (!myMap) return
  if (myMap.navigationService) {
    myMap.navigationService.show()
    return
  }
  initNavigation()
}

/**
 * 隐藏ais航标
 */
const hideNavigation = () => {
  if (!myMap) return
  myMap.navigationService.hide()
}

/**
 * 定位ais航标
 */
const aisNavLocation = (mmsi = '994136855') => {
  if (!myMap) return
  myMap.navigationService.locationNavigationByMMSI(mmsi, true) //定位
  return myMap.navigationService.getNavigationByMMSI(mmsi)
}

/**
 *  selectShipItem 船舶选中
 *  selectedShipUpdate 选中更新
 *  initMap 地图初始化
 *  drawCallBack 点击点的时候回调
 *  drawEndCallBack 结束绘制回调
 *  aiDetectionClick ai检测点击回调函数
 */
const emit = defineEmits([
  'selectShipItem',
  'selectedShipUpdate',
  'initMap',
  'drawCallBack',
  'drawEndCallBack',
  'rightMenuShip',
  'aiDetectionClick',
])

/**
 * 将接口暴漏给外面父组件
 */
defineExpose({
  map: myMap,
  shipShow,
  locate,
  cancelLocate,
  showTrack,
  hideOrShowTrack,
  showTrackForecast,
  hideTrackForeacast,
  showNavigationalWarning,
  hideNavigationalWarning,
  drawLine,
  cancleDrawLineEdit,
  drawLineEdit,
  showLayer,
  drawPoline,
  showArea,
  closeRightMenu,
  appendTrack,
  appendFinish,
  localPirate,
  cancelLocalPirate,
  showNavigation,
  hideNavigation,
  aisNavLocation,
  showShipSj,
  hideShipSj,
})

onBeforeUnmount(() => {
  myMap?.remove()
})
</script>
